/**
 * Autogenerated file don't modify
 */
(function () {
(function () {
    'use strict';

    MoyaComponents.register('curriculum.table', function (el) {
        new TableFilter(el).run();
    });
    var TableFilter = /** @class */ (function () {
        function TableFilter(table) {
            this.el = table;
            this.searchInput = document.getElementById('searchInput');
            this.thElements = Array.from(this.el.querySelectorAll('th[data-sort]'));
            this.rowElements = Array.from(this.el.querySelectorAll('tbody tr.sort'));
            this.allRowElements = Array.from(this.el.querySelectorAll('tbody tr'));
        }
        TableFilter.prototype.run = function () {
            this.setupSorting();
            this.setupSearching();
        };
        TableFilter.prototype.setupSearching = function () {
            var _this = this;
            this.searchInput.addEventListener('input', function () {
                var searchQuery = _this.searchInput.value.trim().toLowerCase();
                var filteredRows = _this.rowElements.filter(function (row) { return _this.rowContainsValue(row, searchQuery); });
                if (searchQuery === '') {
                    filteredRows = _this.allRowElements.filter(function (row) { return _this.rowContainsValue(row, searchQuery); });
                }
                else {
                    // Remove 'asc' and 'desc' classes from all table header elements
                    _this.thElements.forEach(function (th) {
                        th.classList.remove('asc', 'desc');
                    });
                }
                _this.updateTable(filteredRows);
            });
        };
        TableFilter.prototype.setupSorting = function () {
            var _this = this;
            var sortingColumn = null;
            var ascending = true;
            var clickCount = 0; // Counter to track the number of clicks on the same header
            this.thElements.forEach(function (th) {
                th.addEventListener('click', function () {
                    var sortAttribute = th.getAttribute('data-sort');
                    if (!sortAttribute)
                        return;
                    if (sortingColumn === sortAttribute) {
                        clickCount++;
                        // Check if it's the third click, and if so, exit the event handler
                        if (clickCount === 3) {
                            th.classList.remove('desc');
                            _this.allRowElements.filter(function (row) { return _this.rowContainsValue(row, ''); });
                            _this.updateTable(_this.allRowElements);
                            clickCount = 0;
                            return;
                        }
                        ascending = !ascending;
                    }
                    else {
                        sortingColumn = sortAttribute;
                        ascending = true;
                        clickCount = 1;
                    }
                    // Remove the 'asc' or 'desc' class from all other th elements
                    _this.thElements.forEach(function (otherTh) {
                        if (otherTh !== th) {
                            otherTh.classList.remove('asc', 'desc');
                        }
                    });
                    th.classList.toggle('asc', ascending);
                    th.classList.toggle('desc', !ascending);
                    _this.rowElements.sort(function (a, b) { return TableFilter.compareRows(a, b, sortingColumn, ascending); });
                    _this.updateTable(_this.rowElements);
                });
            });
        };
        TableFilter.prototype.rowContainsValue = function (row, searchQuery) {
            return Array.from(row.querySelectorAll('td')).some(function (td) {
                var _a;
                var textContent = ((_a = td.textContent) === null || _a === void 0 ? void 0 : _a.toLowerCase()) || '';
                return textContent.includes(searchQuery);
            });
        };
        TableFilter.compareRows = function (a, b, column, ascending) {
            var aValue = TableFilter.getDataValue(a, column);
            var bValue = TableFilter.getDataValue(b, column);
            return ascending ? aValue.localeCompare(bValue) : bValue.localeCompare(aValue);
        };
        TableFilter.getDataValue = function (row, key) {
            var dataAttribute = row.querySelector("td[data-" + key + "]");
            return (dataAttribute === null || dataAttribute === void 0 ? void 0 : dataAttribute.textContent) || '';
        };
        TableFilter.prototype.updateTable = function (sortedRows) {
            var tbody = this.el.querySelector('tbody');
            if (!tbody)
                return;
            // Clear the table body
            tbody.innerHTML = '';
            // Append the sorted/filtered rows
            sortedRows.forEach(function (row) {
                tbody.appendChild(row);
            });
        };
        return TableFilter;
    }());

}());
typeof tsBuild === 'function' && tsBuild();})();
